export default "/images/immivo.svg?1db3c1e5a54134c94a08f3c82b2b9843";